"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hooks = require("./hooks");

// Renders children iff the variantKey and variantID for the flag matches (if defined)
const Flag = ({
  flagKey,
  children,
  variantKey,
  variantID
}) => {
  const flag = (0, _hooks.useFlag)(flagKey);
  const variantKeyMatches = variantKey === undefined || (flag === null || flag === void 0 ? void 0 : flag.variantKey) === variantKey;
  const variantIDMatches = variantID === undefined || (flag === null || flag === void 0 ? void 0 : flag.variantID) === variantID;
  return variantKeyMatches && variantIDMatches && children;
};

var _default = Flag;
exports.default = _default;